import { EntryPass } from '@/constants'
import { useToast } from './use-toast'
import { apiFetch } from '@/utils'
import { useEffect, useState } from 'react'

export const useGetActiveEntryPass = (walletAddress: `0x${string}`) => {
  const { toast } = useToast()
  const [activeEntryPass, setActiveEntryPass] = useState<EntryPass | null>(null)
  const [isEntryPassLoading, setIsEntryPassLoading] = useState(true)

  const fetchActiveEntryPass = async () => {
    try {
      setIsEntryPassLoading(true)
      const response = await apiFetch(`/v1/entry-passes/${walletAddress}`)

      if (!response.ok) {
        const errorData = await response.json()
        throw new Error(
          errorData.details ||
            errorData.message ||
            `HTTP error! status: ${response.status}`
        )
      }

      const data = await response.json()

      setActiveEntryPass(data)
    } catch (error: any) {
      console.error('Error fetching active entry pass. Reason: ', error)
      toast({
        title: 'Can not fetch active entry pass',
        description:
          error?.message || 'An error occurred while fetching active entry pass'
      })
    } finally {
      setIsEntryPassLoading(false)
    }
  }

  useEffect(() => {
    walletAddress && !activeEntryPass && fetchActiveEntryPass()
  }, [walletAddress, activeEntryPass])

  return {
    activeEntryPass,
    isEntryPassLoading
  }
}
